import { render } from "./ViewsDetailsView.vue?vue&type=template&id=a924b190&scoped=true"
import script from "./ViewsDetailsView.vue?vue&type=script&lang=js"
export * from "./ViewsDetailsView.vue?vue&type=script&lang=js"

import "./ViewsDetailsView.vue?vue&type=style&index=0&id=a924b190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a924b190"]])

export default __exports__